import { Link } from '@reach/router'
import React from 'react'
import './see-all-categorie.scss'

interface SeeAllCategorieProps {
  departamentSlug: string
  closeMenu?: () => void
  validation?: boolean
  categorieSlug: string
  categorieTitle: string
  setCurrentCategorie?: (currentCategorie: string) => void
}

export const SeeAllCategorie = ({
  closeMenu,
  validation,
  departamentSlug,
  categorieSlug,
  setCurrentCategorie,
  categorieTitle,
}: SeeAllCategorieProps) => {
  const singleCategorieTitle = `${categorieTitle}-categorie-title`

  if (!validation) {
    return null
  }

  return (
    <div className="see-all-categories">
      <Link
        onClick={() => {
          closeMenu?.()
          setCurrentCategorie?.(singleCategorieTitle)
        }}
        to={`/${departamentSlug}/${categorieSlug}`}
        data-store-link
      >
        <span>Ver tudo</span>
      </Link>
    </div>
  )
}
